import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

export default function About() {
  const { ref, isVisible } = useScrollAnimation();
  const { ref: ref2, isVisible: isVisible2 } = useScrollAnimation();

  return (
    <section className="py-14 md:py-24 px-5 md:px-8 bg-stone-50">
      <div className="max-w-7xl mx-auto">
        {/* 스피루리나 */}
        <div ref={ref} className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-16 items-center mb-16 md:mb-24">
          <div className={`${isVisible ? 'animate-fade-in-left' : 'opacity-0'}`}>
            <span className="inline-block px-4 py-1.5 rounded-full bg-emerald-50 text-emerald-600 text-xs font-semibold mb-3 md:mb-4">
              스피루리나
            </span>
            <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4 md:mb-5 leading-tight" style={{ fontFamily: 'Noto Serif KR, serif' }}>
              지구상 가장 완벽한<br /><strong>슈퍼푸드 스피루리나</strong>
            </h2>
            <p className="text-xs md:text-sm text-gray-500 leading-relaxed mb-5 md:mb-6">
              스피루리나는 35억 년 전부터 지구에 존재해온 미세조류로, 단백질 함량이 60% 이상인 자연의 완전식품입니다. 비타민, 미네랄, 항산화 성분이 풍부하여 면역력 강화와 피로 회복에 탁월한 효과가 있습니다.
            </p>
            <div className="grid grid-cols-3 gap-3 md:gap-4 mb-6 md:mb-8">
              <div className="text-center p-3 md:p-4 bg-white rounded-xl">
                <p className="text-lg md:text-2xl font-bold text-emerald-600">60%+</p>
                <p className="text-[10px] md:text-xs text-gray-400 mt-1">단백질 함량</p>
              </div>
              <div className="text-center p-3 md:p-4 bg-white rounded-xl">
                <p className="text-lg md:text-2xl font-bold text-emerald-600">46종</p>
                <p className="text-[10px] md:text-xs text-gray-400 mt-1">영양소 함유</p>
              </div>
              <div className="text-center p-3 md:p-4 bg-white rounded-xl">
                <p className="text-lg md:text-2xl font-bold text-emerald-600">95%</p>
                <p className="text-[10px] md:text-xs text-gray-400 mt-1">소화 흡수율</p>
              </div>
            </div>
            <a
              href="#products"
              onClick={(e) => {
                e.preventDefault();
                document.getElementById('products')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="inline-flex items-center gap-2 text-sm font-semibold text-emerald-600 hover:text-emerald-700 transition-colors cursor-pointer group"
            >
              스피루리나 제품 보기
              <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center group-hover:translate-x-1 transition-transform"></i>
            </a>
          </div>

          <div className={`relative ${isVisible ? 'animate-fade-in-right' : 'opacity-0'}`}>
            <div className="w-full h-[300px] sm:h-[360px] md:h-[420px] rounded-2xl overflow-hidden">
              <img
                src="https://storage.readdy-site.link/project_files/fab39877-057d-4165-9475-a35374cb4014/39229809-5b7c-4182-a3dc-611e808ad51d___1_1.jpg?v=22f7d1d2f402b06ac30da9e380ca1fa7"
                alt="프리미엄 스피루리나 파우더와 정제"
                title="자연담은 프리미엄 스피루리나"
                className="w-full h-full object-cover object-center"
              />
            </div>
            <div className="absolute -bottom-4 left-4 md:-bottom-6 md:-left-6 bg-white rounded-xl p-3 md:p-4 shadow-lg">
              <div className="flex items-center gap-2 md:gap-3">
                <div className="w-8 h-8 md:w-10 md:h-10 rounded-full bg-emerald-100 flex items-center justify-center">
                  <i className="ri-award-fill text-emerald-600 w-4 h-4 md:w-5 md:h-5 flex items-center justify-center"></i>
                </div>
                <div>
                  <p className="text-[11px] md:text-xs font-bold text-gray-900">유기농 인증</p>
                  <p className="text-[10px] md:text-xs text-gray-400">USDA Organic</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* 약손콩 */}
        <div ref={ref2} className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-16 items-center">
          <div className={`relative order-1 md:order-1 ${isVisible2 ? 'animate-fade-in-left' : 'opacity-0'}`}>
            <div className="w-full h-[300px] sm:h-[360px] md:h-[420px] rounded-2xl overflow-hidden">
              <img
                src="https://storage.readdy-site.link/project_files/fab39877-057d-4165-9475-a35374cb4014/e638276f-9e94-4716-bc0b-c598f1919967_YAKSONKONGE_11.jpg?v=2b745acb2616ef0d1c374f92935c8f51"
                alt="프리미엄 약손콩과 약손콩 환"
                title="자연담은 프리미엄 약손콩"
                className="w-full h-full object-cover object-center"
              />
            </div>
            <div className="absolute -bottom-4 right-4 md:-bottom-6 md:-right-6 bg-white rounded-xl p-3 md:p-4 shadow-lg">
              <div className="flex items-center gap-2 md:gap-3">
                <div className="w-8 h-8 md:w-10 md:h-10 rounded-full bg-amber-100 flex items-center justify-center">
                  <i className="ri-plant-fill text-amber-600 w-4 h-4 md:w-5 md:h-5 flex items-center justify-center"></i>
                </div>
                <div>
                  <p className="text-[11px] md:text-xs font-bold text-gray-900">국내산 무농약</p>
                  <p className="text-[10px] md:text-xs text-gray-400">전통 재배 방식</p>
                </div>
              </div>
            </div>
          </div>

          <div className={`order-2 md:order-2 ${isVisible2 ? 'animate-fade-in-right' : 'opacity-0'}`}>
            <span className="inline-block px-4 py-1.5 rounded-full bg-amber-50 text-amber-600 text-xs font-semibold mb-3 md:mb-4">
              약손콩
            </span>
            <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4 md:mb-5 leading-tight" style={{ fontFamily: 'Noto Serif KR, serif' }}>
              한국 전통의 건강 비결<br /><strong>프리미엄 약손콩</strong>
            </h2>
            <p className="text-xs md:text-sm text-gray-500 leading-relaxed mb-5 md:mb-6">
              약손콩은 일반 콩보다 이소플라본 함량이 월등히 높은 한국 토종 콩입니다. 갱년기 건강, 뼈 건강, 항산화 효과에 탁월하며, 15년 이상의 전통 재배 방식으로 최상의 품질을 유지합니다.
            </p>
            <div className="grid grid-cols-3 gap-3 md:gap-4 mb-6 md:mb-8">
              <div className="text-center p-3 md:p-4 bg-white rounded-xl">
                <p className="text-lg md:text-2xl font-bold text-amber-600">3배</p>
                <p className="text-[10px] md:text-xs text-gray-400 mt-1">이소플라본</p>
              </div>
              <div className="text-center p-3 md:p-4 bg-white rounded-xl">
                <p className="text-lg md:text-2xl font-bold text-amber-600">15년</p>
                <p className="text-[10px] md:text-xs text-gray-400 mt-1">전통 재배</p>
              </div>
              <div className="text-center p-3 md:p-4 bg-white rounded-xl">
                <p className="text-lg md:text-2xl font-bold text-amber-600">100%</p>
                <p className="text-[10px] md:text-xs text-gray-400 mt-1">국내산 원료</p>
              </div>
            </div>
            <a
              href="#products"
              onClick={(e) => {
                e.preventDefault();
                document.getElementById('products')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="inline-flex items-center gap-2 text-sm font-semibold text-amber-600 hover:text-amber-700 transition-colors cursor-pointer group"
            >
              약손콩 제품 보기
              <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center group-hover:translate-x-1 transition-transform"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
